async function t(t,{filter:e}){return e.request({method:"eth_uninstallFilter",params:[e.id]})}export{t as uninstallFilter};
